import i18n from 'modules/core/lib/i18n'

import { PayrollStatus } from 'modules/payroll_bundle/lib/enums'

export function getPreviousPageText(status: PayrollStatus) {
  return i18n.t('payroll_bundle.policy_period.cycle_process.actions.previous_step')
}

export function getNextPageText(status: PayrollStatus) {
  return status === PayrollStatus.PAID
    ? i18n.t('payroll_bundle.policy_period.cycle_process.actions.finish_process')
    : i18n.t('payroll_bundle.policy_period.cycle_process.actions.next_step')
}

export function getReturnToStepText() {
  return i18n.t('payroll_bundle.policy_period.cycle_process.actions.return_to_step')
}

export function getResetToStepText() {
  return i18n.t('payroll_bundle.policy_period.cycle_process.actions.reset_to_step')
}
